import { useSearchParams } from 'react-router-dom';
import styled, { css } from 'styled-components';

const StyledFilter = styled.div`
  padding: 0.4rem;
  display: flex;
  gap: 0.4rem;
`;

const FilterButton = styled.button`
  background-color: #3c3c4360;
  border: none;

  ${(props) =>
    props.active &&
    css`
      background-color: #5ac8fa;
      color: #fff;
    `}

  border-radius: 8px;
  font-weight: 500;
  font-size: 0.8rem;
  /* To give the same height as select */
  padding: 0.4rem 0.6rem;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    background-color: #5ac8fa;
    color: #fff;
  }
`;

function Filter({ filterField, options }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentFilter = searchParams.get(filterField) || options.at(0).value;

  function handleClick(value) {
    searchParams.set(filterField, value);
    setSearchParams(searchParams);
  }

  return (
    <StyledFilter>
      {options.map((option) => (
        <FilterButton
          key={option.value}
          onClick={() => handleClick(option.value)}
          active={option.value === currentFilter}
          disabled={option.value === currentFilter}
        >
          {option.label}
        </FilterButton>
      ))}
    </StyledFilter>
  );
}

export default Filter;
